
export default {
  props: {
    page: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      latestNewsData: {
        show_background_color: true,
        load_automatically: true,
      },
    }
  },

  computed: {
    blogPost() {
      return this.page
    },

    hasImage() {
      return this.blogPost?.image
    },
  },

  methods: {
    componentsContainsType(type) {
      return this.page.blog_post_components.some(
        (component) => component.type === type
      )
    },
  },
}
